<template lang="pug">
  div.mb-3(v-if='isVisible')
    v-row.my-2.fee(v-for='fee in fees' :key='fee.layoutOrder + `-${label.toLowerCase()}`' align='center' :class='fee.cssClass')
      v-col.fee-label(cols='auto') {{ fee.secondaryLabel }}
      v-col.fee-value(cols=4 md=3 lg=4)
        v-text-field(
          :class="`fee-value-field-${label.toLowerCase()}`"
          :key="`${type}-${refreshKey}`"
          dense single-line filled rounded hide-details
          placeholder='0.00'
          type='number'
          step='.01'
          :suffix='suffix'
          :rules='[rules.positive]'
          :value='fee.displayedValue'
          @blur='handleUpdateValue(fee.layoutOrder, type,  ...arguments)'
          )
      v-col.fee-custom-label(cols='auto')
        v-text-field.fixed-custom-label-field(
          v-if='fee.isLabelFixed'
          dense single-line hide-details disabled
          append-outer-icon='mdi-lock'
          :value='fee.label'
          )
        v-text-field.custom-label-field(
          v-else
          placeholder='Custom Label'
          dense single-line hide-details
          append-outer-icon='mdi-close'
          :value='fee.label'
          @blur='handleUpdateLabel(fee.layoutOrder, fee.type, ...arguments)'
          @click:append-outer='handleDeleteFee(fee.layoutOrder, fee.type)'
          )

    v-btn.mt-3(:class="`add-${label.toLowerCase()}-fee-btn`" text color='primary' @click="handleAddFee(type)" :disabled='fees.length >= 5') + Add {{ label }} Fee
</template>

<script>

export default {
  props: {
    fees: {
      type: Array
    },
    type: {
      type: String
    },
    label: {
      type: String
    },
    suffix: {
      type: String
    },
    isVisible: {
      type: Boolean
    },
    refreshKey: {
      type: Number
    }
  },
  data () {
    return {
      rules: {
        positive: v => v >= 0 || 'Positive numbers only'
      }
    }
  },
  methods: {
    handleUpdateValue (layoutOrder, type, ...args) {
      this.$emit('updateValue', layoutOrder, type, ...args)
    },
    handleUpdateLabel (layoutOrder, type, ...args) {
      this.$emit('updateLabel', layoutOrder, type, ...args)
    },
    handleDeleteFee (layoutOrder, type) {
      this.$emit('deleteFee', layoutOrder, type)
    },
    handleAddFee (type) {
      this.$emit('addFee', type)
    }
  }
}
</script>
